<script lang="ts">
import { inject } from 'vue'
import FullScreen from 'ol/control/FullScreen'
import type Map from 'ol/Map.js'

export default {
    name: 'DkOlFullscreen',
    components: {},
    props: {
        tipLabel: { type: String, required: false, default: "Plein écran"},
        source: { type: String, required: false, default: ""},
    },
    data() {
        return {
            fullscreen: null,
            map: inject('map')
        }
    },
    mounted() {
        this.fullscreen = new FullScreen({
            tipLabel: this.tipLabel,
            source: this.source
        });
        this.map.addControl(this.fullscreen);
    },
    unmounted(): void {
        this.map.removeControl(this.fullscreen)
        delete this.fullscreen
    },
    methods: {},
    render() {
        return null
    },
}
</script>
